import React from "react";
import PropTypes from "prop-types";
import {Model} from '@morningtrain/react-resources';
import {Input} from "@morningtrain/react-fields";

function ForgotPasswordForm(props) {
    return (
        <Model namespace={props.namespace}
               resourceName={props.resourceName}
               submitoperationName={props.submitOperationName}
               operationName={props.operationName}
               submittable={true}>

            <div className="form-content">
                <Input name={props.inputName} label={props.inputLabel} required={true}/>
                {props.children}
            </div>

            <div className="modal-footer">
                <input type='submit'/>
            </div>

        </Model>
    );
}

ForgotPasswordForm.defaultProps = {
    namespace: 'auth',
    resourceName: 'password',
    submitOperationName: 'forgot_password',
    operationName: 'forgot_password',
    inputName: 'email',
    inputLabel: 'Email',
};

ForgotPasswordForm.propTypes = {
    namespace: PropTypes.string,
    resourceName: PropTypes.string,
    submitOperationName: PropTypes.string,
    operationName: PropTypes.string,
    inputName: PropTypes.string,
    inputLabel: PropTypes.string,
};

export default ForgotPasswordForm;
